import { CheckoutSubscriptionResultPage } from '@/pages/checkout-subscription-result'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/checkout-subscription-result/$sessionId',
)({
  component: CheckoutSubscriptionResultPage,
})
